"use strict";

angular.module('app').filter('filterVariants', function() {
    return function(input, option, cabin, order) {
        if (cabin) {
            return _.sortBy(_.filter(input, {
                isShared: true
            }),'isDiver').reverse();
        }

        _.each(input, function(val, key) {
            var title = val[option].toLowerCase();

            if (title.match('single')) {
                val.order = order ? 0 : 999;
            } else if (title.match('double')) {
                val.order = 1;
            } else if (title.match('shared')) {
                val.order = 0;
            } else if (title.match('3') || title.match('triple')) {
                val.order = 2;
            } else if (title.match('4')) {
                val.order = 3;
            } else {
                val.order = 5;
            }
        });

        var list = _.sortBy(input, 'order'),
            groupSeparator = 0,
            key,
            length = list.length;

        for (var i = 0; i < length; i++) {
            if (list[i + 1] && list[i].order === list[i + 1].order) {
                if (groupSeparator === 0) {
                    key = i;
                }

                groupSeparator++;
            } else {
                if (groupSeparator === 0) {
                    list[i].firstElement = true;
                } else {
                    list[key].firstElement = true;
                }
                groupSeparator = 0;
            }
        }

        return list;
    };
});